import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { DeviceService, WINDOW } from '@frontend/vanilla/core';

import { BannerTrackingService } from './banner-tracking.service';
import { GameLauncherModel, GameLauncherSection } from './game-launcher.resolver';
import { GamesService } from './games.service';

// this component is only serving deep links game launch is being handled on each
// separate component, there is no need to redirect here, needs to be cleaned up
// in the future
@HooksWireup()
@Component({
    selector: 'ms-game-launcher',
    template: '',
    standalone: true,
})
export class GameLauncherComponent extends OnRouteResolve<GameLauncherModel> {
    constructor(
        private gamesService: GamesService,
        private trackingService: BannerTrackingService,
        private deviceService: DeviceService,
        route: ActivatedRoute,
    ) {
        super(route);
    }

    onRouteResolved(model: GameLauncherModel): void {
        const section = model.section || GameLauncherSection.Gyml;

        switch (section) {
            case GameLauncherSection.Gyml:
                if (this.deviceService.isMobile) {
                    this.trackingService.trackGymlLaunch({
                        name: model.name,
                        index: model.position,
                        displayName: model.title,
                        provider: model.provider,
                        lobbyPosition: model.lobbyPosition,
                        pageName: '',
                        url: this.gamesService.getLaunchUrl(model.name),
                    });
                }
                break;
            case GameLauncherSection.Link:
                this.trackingService.trackLinkGameLaunch(model.name);
                break;
            case GameLauncherSection.Jackpot:
                this.trackingService.trackJackpotGameLaunch(model.name);
                break;
        }

        this._window.open(this.gamesService.getLaunchUrl(model.name), '_self');
    }

    private readonly _window = inject(WINDOW);
}
